import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  stepper: {
    padding: theme.spacing(3, 0, 5, 0),
    background: 'transparent',
  },
  contentSplitter: {
    marginTop: theme.spacing(2),
  },
  downContainer: {
    padding: theme.spacing(0, 1.5),
  },
  botoesFormulario: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    width: '100%',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
    },
  },
  botoesDireita: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  botaoContainer: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      '& > button': {
        width: '100% !important',
      },
    },
  },
  titleCampo: {
    fontSize: '15px',
    marginTop: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  dadosConfirmacao: {
    padding: theme.spacing(1),
  },
}))

export default useStyles
